import { render, staticRenderFns } from "./ServiceTrashItem.vue?vue&type=template&id=1874d8d7&scoped=true&"
import script from "./ServiceTrashItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceTrashItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTrashItem.vue?vue&type=style&index=0&id=1874d8d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874d8d7",
  null
  
)

export default component.exports